import { useEffect, useState } from 'react'

import Select from '../ConfigurazioneNora/Select'
import { contaFiltri, FILTRI_EXTRA, nomeEnvironment, nomeFlusso } from './Functions'
import { useRitardato } from './hooks'
import { Icona } from './Icon'
import { t } from './testi'

/**
 * La barra dei filtri dell'elenco run. La ricerca per nome aspetta che si smetta di
 * scrivere prima di interrogare il server; gli altri filtri valgono subito. Per svuotare
 * anche il campo di ricerca dopo un azzeramento, chi la usa cambia la `key`.
 * @param {Object} props - Proprietà
 * @param {Object} props.filtri - Lo stato dei filtri
 * @param {(campo: string, valore: string) => void} props.onChange - Cambia un filtro
 * @param {() => void} props.onAzzera - Azzera tutti i filtri
 * @param {Array<Object>} props.environments - Gli environment
 * @param {string[]} props.flussi - I flussi presenti nelle run
 * @param {Array<number|null>} props.versioni - Le versioni dell'harness presenti
 */
export const FiltriRun = ({ filtri, onChange, onAzzera, environments, flussi, versioni }) => {
  const [testo, setTesto] = useState(filtri.testo)
  const testoCalmo = useRitardato(testo)
  const [extraAperti, setExtraAperti] = useState(false)
  const extraAttivi = contaFiltri(filtri, FILTRI_EXTRA)
  const totaleAttivi = contaFiltri(filtri)

  // Il testo che il server vede segue quello digitato, con il ritardo.
  useEffect(() => {
    if (testoCalmo !== filtri.testo) onChange('testo', testoCalmo)
    // Solo `testoCalmo` deve scatenare l'aggiornamento.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testoCalmo])
  return (
    <div className="ae-filtri">
      <label className="ae-filtro-campo">
        <span>{t.aeNome}</span>
        <input
          className="ninput"
          type="search"
          placeholder={t.aeCerca}
          value={testo}
          onChange={(e) => setTesto(e.target.value)}
        />
      </label>
      <div className="ae-filtro-campo">
        <label htmlFor="ae-filtro-environment">{t.aeEnvironment}</label>
        <Select
          id="ae-filtro-environment"
          value={filtri.environmentId}
          onChange={(v) => onChange('environmentId', v)}
        >
          <option value="">{t.aeTuttiEnv}</option>
          {environments.map(({ id, codSociety, societyName }) => (
            <option key={id} value={id}>
              {nomeEnvironment(id, environments) || `${id} · ${codSociety ?? societyName}`}
            </option>
          ))}
        </Select>
      </div>
      <div className="ae-filtro-campo">
        <label htmlFor="ae-filtro-harness">{t.aeHarness}</label>
        <Select
          id="ae-filtro-harness"
          value={filtri.versioneHarness}
          onChange={(v) => onChange('versioneHarness', v)}
        >
          <option value="">{t.aeTuttiHarness}</option>
          {versioni.map((versione) => (
            <option key={versione ?? 'legacy'} value={versione ?? 'legacy'}>
              {versione == null ? t.aeSenzaVersione : `v${versione}`}
            </option>
          ))}
        </Select>
      </div>
      <div className="ae-filtro-extra">
        <button
          type="button"
          className={`nbtn nbtn--ghost ae-filtro-extra__bottone ${extraAttivi ? 'is-attivo' : ''}`}
          aria-expanded={extraAperti}
          aria-controls="ae-filtri-extra"
          onClick={() => setExtraAperti((aperto) => !aperto)}
        >
          <Icona nome="pi-sliders-h" /> {t.aeAltriFiltri}
          {extraAttivi ? <span className="ae-filtro-extra__numero">{extraAttivi}</span> : null}
        </button>
      </div>
      {totaleAttivi ? (
        <button
          type="button"
          className="nbtn nbtn--ghost nbtn--sm ae-filtri__azzera"
          onClick={onAzzera}
        >
          <Icona nome="pi-filter-slash" /> {t.aeAzzeraFiltri} ({totaleAttivi})
        </button>
      ) : null}
      {extraAperti ? (
        <div id="ae-filtri-extra" className="ae-filtri__extra">
          <div className="ae-filtro-campo">
            <label htmlFor="ae-filtro-flusso">{t.aeFlusso}</label>
            <Select
              id="ae-filtro-flusso"
              value={filtri.flusso}
              onChange={(v) => onChange('flusso', v)}
            >
              <option value="">{t.aeTuttiFlussi}</option>
              {flussi.map((mode) => (
                <option key={mode} value={mode}>
                  {nomeFlusso(mode)}
                </option>
              ))}
            </Select>
          </div>
          <div className="ae-filtro-campo">
            <label htmlFor="ae-filtro-stato">{t.aeColEsito}</label>
            <Select
              id="ae-filtro-stato"
              value={filtri.stato}
              onChange={(v) => onChange('stato', v)}
            >
              <option value="">{t.aeTuttiStati}</option>
              <option value="completata">{t.aeCompletata}</option>
              <option value="in_corso">{t.aeInCorso}</option>
              <option value="in_coda">{t.aeInCoda}</option>
              <option value="fermata">{t.aeFermata}</option>
              <option value="fallita">{t.aeFallita}</option>
            </Select>
          </div>
          <div className="ae-filtro-campo">
            <label htmlFor="ae-filtro-dal">{t.aeDal}</label>
            <input
              id="ae-filtro-dal"
              className="ninput"
              type="date"
              value={filtri.dal}
              onChange={(e) => onChange('dal', e.target.value)}
            />
          </div>
          <div className="ae-filtro-campo">
            <label htmlFor="ae-filtro-al">{t.aeAl}</label>
            <input
              id="ae-filtro-al"
              className="ninput"
              type="date"
              value={filtri.al}
              onChange={(e) => onChange('al', e.target.value)}
            />
          </div>
        </div>
      ) : null}
    </div>
  )
}
